export default {
  state: {
    settings: [],
    settingsDict: {},
  },
  getters: {
    getSetting: (state) => (key) => {
      return state.settingsDict[key] || null;
    },
    getSettingValue: (state) => (key) => {
      const setting = state.settingsDict[key];
      return setting ? setting.value : null;
    },
    getSettingsByGroup: (state) => (group) => {
      return state.settings.filter((setting) => setting.group === group);
    },
  },
  mutations: {
    initialiseSettings(state, settings) {
      state.settings = settings;
      // Create dictionary for fast lookup
      state.settingsDict = settings.reduce((dict, setting) => {
        dict[setting.key] = setting;
        return dict;
      }, {});
    },
    updateSetting(state, { key, value }) {
      const setting = state.settingsDict[key];
      if (setting) {
        setting.value = value;
      }
    },
  },
  actions: {
    initialiseSettings(context, settings) {
      context.commit('initialiseSettings', settings);
    },
    updateSetting(context, { key, value }) {
      context.commit('updateSetting', { key, value });
    },
  },
  modules: {},
};
